<script setup lang="ts">
import type { HelpcenterSidebarNavigationItem } from '@/stores/useNavigationsStore';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import NoDataListItem from '@/components/items/NoDataListItem.vue';
import SimpleLoader from '@/components/loaders/SimpleLoader.vue';
import { useNavigationsStore } from '@/stores/useNavigationsStore';

export interface Props {
  items?: openapi.ArticleListItem[];
  isLoading: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  isLoading: false,
});

const navigationsStore = useNavigationsStore();

function handleClick(articleId: number): void {
  const navigation: HelpcenterSidebarNavigationItem = {
    type: 'article',
    id: articleId,
  };
  navigationsStore.navigations.helpcenterSidebar.push(navigation);
}
</script>

<template>
  <menu
    :class="$style.helpcenterSideBarMenuList"
    data-testid="helpcenterSideBarMenuList"
  >
    <template v-if="props.isLoading">
      <li :class="$style.li">
        <SimpleLoader :class="$style.simpleLoader" />
      </li>
    </template>
    <template v-else-if="!props.items.length">
      <NoDataListItem :class="$style.li">Articles not found</NoDataListItem>
    </template>
    <template v-else>
      <li v-for="item in props.items" :key="item.id" :class="$style.li">
        <router-link to="" @click="handleClick(item.id)">
          {{ item.title }}
        </router-link>
      </li>
    </template>
  </menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.helpcenterSideBarMenuList {
  margin: 0;
  padding: 0;
  list-style: none;
  min-height: 28px;
}
  .li {
    padding: 4px 0;
  }
    .simpleLoader {
      margin: -5px 0;
    }
</style>
